// ManaBoxTips: Wiederverwendbare Tipps-Sektion rund um ManaBox-Workflows.
// Kann in EmptyCollectionGuide oder eigenständig eingebunden werden.
import React from 'react';
import { Lightbulb } from 'lucide-react';
import deckScreenshot1 from '../assets/ManaBox_DeckErstellen (1).jpg';
import deckScreenshot2 from '../assets/ManaBox_DeckErstellen (2).jpg';
import './ManaBoxTips.css';

export default function ManaBoxTips() {
  return (
    <>
      {/* ── Trenner ────────────────────────── */}
      <div className="manabox-tips__divider">
        <div className="manabox-tips__divider-line" />
        <span className="manabox-tips__divider-text">Tipps</span>
        <div className="manabox-tips__divider-line" />
      </div>

      <div className="manabox-tips">
        <div className="manabox-tips__header">
          <h2>
            <Lightbulb size={20} aria-hidden />
            Gut zu wissen
          </h2>
          <p>Tipps, wie du ManaBox und diese Seite am besten zusammen nutzt.</p>
        </div>

        {/* ── Tipp: Decks in Sammlung registrieren ── */}
        <div className="manabox-tips__card">
          <div className="manabox-tips__text">
            <h3>Deck-Karten in deiner Sammlung sichtbar machen</h3>
            <p>
              <strong>ManaBox</strong> ist dein zentrales Sammlungs-Tool. Wir helfen dir, deine Karten
              aus ManaBox hier übersichtlich und durchsuchbar zu machen — inklusive ihrer Bilder,
              Preise und Verfügbarkeit.
            </p>
            <p>
              Damit Karten, die du in Decks verwendest, auch in deiner Sammlung auftauchen,
              musst du die Decks in ManaBox <strong>in deiner Sammlung registrieren</strong>.
              So wissen wir, dass du diese Karten besitzt, sie aber gerade in einem Deck gebunden sind.
            </p>
            <div className="manabox-tips__highlight">
              <strong>Warum ist das wichtig?</strong> Registrierte Deck-Karten erscheinen in deiner
              Sammlung und werden beim Bau neuer Decks nicht als „verfügbar" vorgeschlagen — du
              vermeidest also, Karten doppelt einzuplanen.
            </div>
            <p>
              Öffne in ManaBox ein Deck und tippe auf <strong>„+ In der Sammlung registrieren"</strong>.
              Du kannst dann wählen, ob die Karten direkt hinzugefügt oder aus vorhandenen
              Sammlungskarten gebaut werden sollen.
            </p>
          </div>

          <div className="manabox-tips__screenshots">
            {/* Screenshot 1: Button im Deck */}
            <div className="manabox-tips__screenshot">
              <div className="manabox-tips__img-wrapper">
                <img src={deckScreenshot1} alt="ManaBox – Deck in Sammlung registrieren" />
                {/* Annotation auf „+ In der Sammlung registrieren"-Button */}
                <div
                  className="manabox-tips__annotation"
                  style={{ top: '21%', left: '50%', transform: 'translateX(-50%)' }}
                >
                  <div className="manabox-tips__pulse-ring" />
                </div>
              </div>
              <span className="manabox-tips__screenshot-label">
                Tippe auf „In der Sammlung registrieren"
              </span>
            </div>

            {/* Screenshot 2: Optionen */}
            <div className="manabox-tips__screenshot">
              <div className="manabox-tips__img-wrapper">
                <img src={deckScreenshot2} alt="ManaBox – Registrierungsoptionen" />
              </div>
              <span className="manabox-tips__screenshot-label">
                Wähle, wie das Deck registriert wird
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
